import React, { useState } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'

const Consulta = props => {
    const [data, setData] = useState([])


    const columns = React.useMemo(
        () => [{
            id: 'consulta-beneficiario',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                }
                , {
                    Header: 'Paciente',
                    accessor: 'nome',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'CPF',
                    accessor: 'cpf',
                    ordenamento: {
                        tipo: 'texto'
                    }
                }, {
                    Header: 'Data Nascimento',
                    accessor: 'data_nascimento',
                    ordenamento: {
                        tipo: 'data'
                    }
                }, {
                    Header: 'Grau de Dependência',
                    accessor: 'grau_dependencia',
                    ordenamento: {
                        tipo: 'text'
                    },
                    filtro: {
                        tipo: 'grau_dependencia',
                        idColuna: 'g1.bene_grde_id'
                    }
                }, {
                    Header: 'Beneficiário Titular',
                    accessor: 'nome_titular',
                    ordenamento: {
                        tipo: 'text'
                    },
                    filtro: {
                        tipo: 'beneficiario_titular',
                        idColuna: 'g1.bene_bene_id'
                    }
                },
                // {
                //     Header: 'Empresa Parceira/Plano',
                //     accessor: 'empresa_parceira',
                //     ordenamento: {
                //         tipo: 'text'
                //     },
                //     filtro: {
                //         tipo: 'empresa_parceira',
                //         idColuna: 'g1.bene_empa_id'
                //     }
                // }, 
                {
                    Header: 'Data Registro',
                    accessor: 'data_registro',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    )

    return (
        <>
            <div>
                <DataGridAlternativa data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/atendimento/beneficiario' caminhoConsultaFiltros='/atendimento/beneficiariopaginacao' modulo={props.modulo} titulo={'Consulta Paciente'}
                    tituloLista={'Lista Paciente'}
                    urlCadastro='/atendimento/beneficiario/cadastro' icone={props.icone} />
            </div>
        </>
    )
}

export default Consulta